import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor() {}

  handleError(error: Error): void {
    console.error('Global error handler caught:', error);

    // Check if it's a CORS or network error
    if (error.message.includes('CORS') || error.message.includes('NetworkError')) {
      console.warn('CORS/Network error detected, showing user-friendly message');
      this.showUserFriendlyError(
        'Network connectivity issue detected. Please check your connection and try again.'
      );
    } else if (error.message.includes('maps.googleapis.com')) {
      console.warn('Google Maps error detected, continuing without maps');
      // Don't show error for Google Maps, just log it
    } else {
      // Show generic error for other issues
      this.showUserFriendlyError('An unexpected error occurred. Please try refreshing the page.');
    }
  }

  private showUserFriendlyError(message: string): void {
    // Use AlertService instead of MatSnackBar for consistent notifications
    // This will be handled by the global error interceptor
    console.error('User-friendly error:', message);
  }
}
